import React, { Component } from 'react'
import styled from 'styled-components'
import { upperlower, priceRangeCalculator, getAverageData } from '../utlis/functions'
import { geolocated } from 'react-geolocated'
import {
  Arrow,
  Modal,
  Header,
  Shape,
  CustomSlider,
  XLMMText,
  XXMText,
  Button,
  StyledImage,
  PageWrapper,
  Card,
  FlexWrapper,
  XXLText,
  XXXMText,
  ProgressBar,
  Tooltip,
  ListView,
  Checkbox,
  Icon,
  Circle,
  Counter,
  DefaultText,
  XMText,
  FlexWrap,
  OverlayChild,
  PageLoader,
  CardWrap,
  TextField,
  FormikForm,
  SmallestText,
  XLMText,
  XCMText,
  Radio
} from '../components'
import qs from 'qs'
import { addList } from '../utlis/validators'
import { Formik, Field } from 'formik'
import Cookies from 'js-cookie'
import { API_URL } from '../constants'
import axios from 'axios'
import { roundingValue } from '../utlis/functions'
import {
  isEmpty,
  get,
  size,
  forEach,
  toUpper,
  min,
  max,
  map,
  xor,
  has,
  values,
  truncate,
  uniqBy,
  indexOf
} from 'lodash'

const StyledShape = styled(Shape)`
  left: calc(50% - 0px) !important;
`
const ContentWrap = styled.div`
  width: 100%;
`

const CustomCard = styled(Card)`
  position: Fixed !important;
  top: 60px;
  z-index: 999999;
  max-width: 768px;
`
const CustomFlex = styled(FlexWrapper)`
  div {
    max-width: 340px;
    & > button {
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > button:nth-child(2) {
      width: 410px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      color: #078489;
      margin: 16px 0 0 20px;
    }
  }
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 999999;
  .scan-receipt {
    color: #124b5f !important;
  }
`
const FloatingIcon = styled.div`
  position: absolute;
  left: 4px;
  width: 24px;
  height: 24px;
  top: -11px;
`
const Section = styled.section`
  width: 100%;
  padding: 16px 16px 4px;
`

const CounterFlexWrapper = styled(FlexWrapper)`
  ${props =>
    props.focused &&
    `

  &:before {
    content: '';
    width: 100%;
    height: 120px;
    background: rgba(255, 255, 255, 0.77);
    position: absolute;
    top: 0;
    left: 0;
  }
  &:after {
    content: '';
  }
  & > div {
    position: relative;
  }
`};
`
const ReplaceFlexWrapper = styled(FlexWrapper)`
  ${props =>
    props.isReplaced &&
    `

 &:before {
    content: '';
    width: 100%;
    height: 120px;
    background: #fff;
    opacity: 0.77;
    position: absolute;
    top: 0;
    left: 0;
  }
 
 
`};
`
const mapOrder = (array, order, key) => {
  array.sort(function(a, b) {
    var A = a[key],
      B = b[key]

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1
    } else {
      return -1
    }
  })

  return array
}

class SingleList extends Component {
  state = {
    counterItems: {},
    cardIndex: 0,
    listsData: [],
    listDetails: {},
    shopInStoreMode: false,
    showModal: false,
    deleteList: false,
    renameList: false,
    isLoading: false,
    checkboxes: [],
    scrolledToBottom: false,
    lastScrollPos: 0,
    comingSoonModel: false,
    replacementList: false,
    originalProductCode: {},
    substitutesProducts: [],
    radioButtonProductCode: '',
    storeName: ''
  }

  async fetchListDetails() {
    try {
      const { data: listDetails } = await axios.get(`${API_URL}/ShoppingLists/${this.props.match.params.tab}`)
      this.setState({ listDetails })
    } catch (error) {
      console.error(error)
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.coords === null && get(this.props, 'coords', null)) {
      const {
        data: { status }
      } = await axios.get(
        `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
          this.props.match.params.tab
        }/${this.props.coords.latitude},${this.props.coords.longitude}`
      )
      this.setState({ listsData: status })
    }
  }

  async componentDidMount() {
    window.scrollTo(0, 0)
    this.setState({
      shopInStoreMode: get(this.props, 'location.state.shopInStoreMode', false),
      cardIndex: get(this.props, 'location.state.cardIndex', 0),
      checkboxes: get(this.props, 'location.state.checkboxes', []),
      scrolledToBottom: get(this.props, 'location.state.scrolledToBottom', false),
      showModal: get(this.props, 'location.state.showModal', false),
      replacementList: get(this.props, 'location.state.replacementList', false),
      originalProduct: get(this.props, 'location.state.originalProduct', ''),
      radioButtonProductCode: get(this.props, 'location.state.radioButtonProductCode', ''),
      substitutesProducts: get(this.props, 'location.state.substitutesProducts', ''),
      storeName: get(this.props, 'location.state.storeName', '')
    })

    this.fetchListDetails()
    this.fetchUserShoppingProductList()
  }

  async fetchUserShoppingProductList() {
    this.setState({ isLoading: true })
    try {
      let status = {}
      if (get(this.props, 'coords.latitude', null)) {
        const data = await axios.get(
          `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
            this.props.match.params.tab
          }/${this.props.coords.latitude},${this.props.coords.longitude}`
        )
        status = data.data.status
      } else {
        const data = await axios.get(
          `${API_URL}/UserShoppingListProducts/userShoppingProductList/${Cookies.get('user_id')}/${
            this.props.match.params.tab
          }/null`
        )
        status = data.data.status
      }

      this.setState({ listsData: status, isLoading: false })
    } catch (error) {
      console.error('ERR', error)
      this.setState({ isLoading: false })
    }
  }

  openInstaWarning = () => {}

  createInstaUrl = () => {
    const stores = Object.keys(this.state.listsData)
    const selectedStore = this.state.listsData[stores[this.state.cardIndex]]

    let ingredients = ''
    let quantity = ''

    if (size(selectedStore.products) > 0) {
      forEach(selectedStore.products, item => {
        if (item.isSubstituted === false) {
        } else {
          ingredients += `&ingredients%5B%5D=${encodeURIComponent(item.productName)}`
          quantity += `&quantities%5B%5D=${encodeURIComponent(item.productQuantity)}`
        }
      })

      window.open(
        `https://www.instacart.com/store/partner_recipe?description=Live%20Your%20Values&image_url=https://i.imgur.com/jE9nXn3.png${ingredients}${quantity}&partner_name=greenchoicenow.com&recipe_url=https://app.greenchoice.io&title=GreenChoice&guest=true`,
        '_blank'
      )
    }
  }

  /*  redirectToOuterLink(name) {
    console.log('name', name)
    if (name === 'Freshdirect') {
      window.open('https://www.freshdirect.com/')
    } else if (name === 'Peapod') {
      window.open('https://www.peapod.com/')
    } else if (name === 'Walmart') {
      window.open('https://www.walmart.com/')
    }
  } */
  handleChangeInQuantity = async (grocer, product, action) => {
    if (this.state.listsData[grocer].products[product].userQuantity === 0 && action === 'subtract') {
      return
    }

    if (grocer === 'Master List') {
      // console.log(grocer, product, action)
      const query = {
        filter: {
          where: {
            userId: Cookies.get('user_id'),
            shoppingListId: this.state.listDetails.id,
            productCode: product
          }
        }
      }

      const { data } = await axios.get(`${API_URL}/UserShoppingListProducts?${qs.stringify(query)}`)

      if (this.state.listsData[grocer].products[product].userQuantity === 1 && action === 'subtract') {
        if (window.confirm('Do you really want to remove the product from the list?')) {
          if (data.length > 0) {
            await axios.delete(`${API_URL}/UserShoppingListProducts/${data[0].id}`)
            this.fetchListDetails()
            this.fetchUserShoppingProductList()
            return
          }
        } else {
          return
        }
      }

      if (data.length > 0) {
        await axios.patch(`${API_URL}/UserShoppingListProducts/${data[0].id}`, {
          quantity:
            action === 'add'
              ? this.state.listsData[grocer].products[product].userQuantity + 1
              : this.state.listsData[grocer].products[product].userQuantity - 1
        })
        this.fetchListDetails()
        this.fetchUserShoppingProductList()
      }

      // await axios.patch(``)
    }

    this.setState({
      listsData: {
        ...this.state.listsData,
        [grocer]: {
          ...this.state.listsData[grocer],
          products: {
            ...this.state.listsData[grocer].products,
            [product]: {
              ...this.state.listsData[grocer].products[product],
              userQuantity:
                action === 'add'
                  ? this.state.listsData[grocer].products[product].userQuantity + 1
                  : this.state.listsData[grocer].products[product].userQuantity - 1
            }
          }
        }
      }
    })
  }
  handleScroll = e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    if (this.state.lastScrollPos > e.currentTarget.scrollTop) {
      this.setState({ scrolledToBottom: false, lastScrollPos: e.currentTarget.scrollTop })
    } else if (bottom) {
      this.setState({ scrolledToBottom: true })
    }
  }
  onScroll = e => {
    if (e.nativeEvent.wheelDelta > 0) {
      this.setState({ scrolledToBottom: false })
    } else {
    }
  }

  updateReplacement = async () => {
    const { radioButtonProductCode, storeName, originalProduct } = this.state

    const query = {
      filter: {
        where: {
          userId: Cookies.get('user_id'),
          originalProductCode: originalProduct.productCode,
          storeName
        }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserSubstituteProducts`, {
      params: { filter: query.filter }
    })
    if (data && data.length > 0) {
      if (radioButtonProductCode === 'NONE') {
        await axios.delete(`${API_URL}/UserSubstituteProducts/${data[0].id}`)
        this.setState({ showModal: false, replacementList: false })
        this.fetchListDetails()
        this.fetchUserShoppingProductList()
        return
      }
      await axios.patch(`${API_URL}/UserSubstituteProducts/${get(data, '0.id', '')}`, {
        originalProductCode: originalProduct.productCode,
        substituteProductCode: radioButtonProductCode,
        storeName,
        userId: Cookies.get('user_id')
      })
    } else {
      await axios.post(`${API_URL}/UserSubstituteProducts`, {
        originalProductCode: originalProduct.productCode,
        substituteProductCode: radioButtonProductCode,
        storeName,
        userId: Cookies.get('user_id')
      })
    }
    this.setState({ showModal: false })
    this.fetchListDetails()
    this.fetchUserShoppingProductList()
  }

  render() {
    const {
      counterItems,
      renameList,
      isLoading,
      deleteList,
      listsData,
      cardIndex,
      shopInStoreMode,
      listDetails,
      showModal,
      scrolledToBottom,
      checkboxes,
      comingSoonModel,
      replacementList,
      warningModal
    } = this.state

    // get keys from the listData
    const stores = Object.keys(listsData)

    const selectedStore = listsData[stores[cardIndex]]
    const sortOrder = [
      'produce',
      'meat',
      'seafood',
      'deli',
      'fresh cheese',
      'packaged cheese',
      'dairy and eggs',
      'pantry',
      'beverages',
      'frozen',
      'bread and bakery',
      'prepared foods',
      'meals',
      'organic'
    ]

    const unSortedProduts = values(get(selectedStore, 'products', {}))

    const sortedProducts = mapOrder(unSortedProduts, sortOrder, 'productCategory')
    const aggregates = {}

    stores.forEach(store => {
      let totalQty = 0
      let totalGs = 0
      let lowerTotalPrice = 0
      let upperTotalPrice = 0
      let asterisk = 0
      forEach(listsData[store].products, product => {
        // check if master
        // Get the price range
        // else
        // get the actual price of the items; it should only include the price of the replaced product or the actual product.

        if (store === 'Master List') {
          const priceRange = get(product, 'productCost', []).map(item => {
            if (!item.productPriceOriginal) asterisk++
            return item.productPriceSale
              ? item.productPriceSale * product.userQuantity
              : item.productPriceOriginal
              ? item.productPriceOriginal * product.userQuantity
              : 'NaN'
          })
          lowerTotalPrice += min(priceRange) === 'NaN' ? 0 : min(priceRange)
          upperTotalPrice += max(priceRange) === 'NaN' ? 0 : max(priceRange)
          totalQty += product.userQuantity
          totalGs += product.totalGs * product.userQuantity
        } else {
          let price = 0

          if (has(product, 'substitutedProductList')) {
            if (get(product, 'substitutedProductList', []).length > 0) {
              if (has(product, 'userSubstituteProduct')) {
                if (!get(product, 'userSubstituteProduct.productPriceOriginal', 0)) asterisk++
                price = get(product, 'userSubstituteProduct.productPriceSale', 0)
                  ? get(product, 'userSubstituteProduct.productPriceSale', 0) * product.userQuantity
                  : get(product, 'userSubstituteProduct.productPriceOriginal', 0)
                  ? get(product, 'userSubstituteProduct.productPriceOriginal', 0) * product.userQuantity
                  : 'NaN'
                totalQty += product.userQuantity
                totalGs += get(product, 'userSubstituteProduct.totalGs', 0) * product.userQuantity
              } else {
                price = 0
              }
            } else {
              price = 0
            }
          } else {
            if (!get(product, 'productPriceOriginal', 0)) asterisk++
            price = get(product, 'productPriceSale', 0)
              ? get(product, 'productPriceSale', 0) * product.userQuantity
              : get(product, 'productPriceOriginal', 0)
              ? get(product, 'productPriceOriginal', 0) * product.userQuantity
              : 'NaN'
            totalQty += product.userQuantity
            totalGs += get(product, 'totalGs', 0) * product.userQuantity
          }

          /* const price =
            get(
              product,
              'userSubstituteProduct.productPriceSale',
              get(
                product,
                'userSubstituteProduct.productPriceOriginal',
                get(product, 'productPriceSale', get(product, 'productPriceOriginal', 'NaN'))
              )
            ) * product.userQuantity */
          lowerTotalPrice += min([price]) === 'NaN' ? 0 : min([price])
          upperTotalPrice += max([price]) === 'NaN' ? 0 : max([price])
        }

        /* if (product.productCost) {
            let priceRange = 0
            if (has(product, 'userSubstituteProduct')) {
              if (get(product, 'userSubstituteProduct.substituteProductCode', '') === 'NONE') {
                console.log('NONE')
                priceRange = ['NaN']
              } else {
                priceRange = get(product, 'userSubstituteProduct.productPriceSale', null)
                  ? [
                      get(product, 'userSubstituteProduct.productPriceSale', null) *
                        product.userQuantity
                    ]
                  : get(product, 'userSubstituteProduct.productPriceOriginal', null)
                  ? [
                      get(product, 'userSubstituteProduct.productPriceOriginal', null) *
                        product.userQuantity
                    ]
                  : 'NaN'
              }
            } else {
              priceRange = get(product, 'productCost', []).map(item =>
                item.productPriceSale
                  ? item.productPriceSale * product.userQuantity
                  : item.productPriceOriginal
                  ? item.productPriceOriginal * product.userQuantity
                  : 'NaN'
              )
            }
            console.log('priceRange final', priceRange)
            lowerTotalPrice += min(priceRange) === 'NaN' ? 0 : min(priceRange)
            upperTotalPrice += max(priceRange) === 'NaN' ? 0 : max(priceRange)
            console.log('lowerTotalPrice', lowerTotalPrice, upperTotalPrice)
          } else {
            let priceR = 0
            if (has(product, 'userSubstituteProduct')) {
              if (get(product, 'userSubstituteProduct.substituteProductCode', '') === 'NONE') {
                priceR = product.productPriceSale
                  ? product.productPriceSale * product.userQuantity
                  : product.productPriceOriginal * product.userQuantity
              } else {
                priceR = product.userSubstituteProduct.productPriceSale
                  ? product.userSubstituteProduct.productPriceSale * product.userQuantity
                  : product.userSubstituteProduct.productPriceOriginal * product.userQuantity
              }
            } else {
              priceR = product.productPriceSale
                ? product.productPriceSale * product.userQuantity
                : product.productPriceOriginal * product.userQuantity
            }

            lowerTotalPrice += priceR
            upperTotalPrice += priceR
          } */
      })
      const avgGs = totalQty > 0 ? Math.round(totalGs / totalQty) : 0
      aggregates[store] = {
        store,
        totalQty,
        lowerTotalPrice: roundingValue(lowerTotalPrice),
        upperTotalPrice: roundingValue(upperTotalPrice),
        avgGs,
        asterisk
      }
    })
    const selectedAggregate = aggregates[stores[cardIndex]]
    return (
      <React.Fragment>
        <Header
          title={
            shopInStoreMode
              ? stores.length > 0 && stores[cardIndex].replace('Insta_', '')
              : truncate(listDetails.name, {
                  length: 18
                }) || 'List'
          }
          icon="arrowBack"
          onClickBack={
            shopInStoreMode
              ? () => this.setState({ shopInStoreMode: false })
              : () => this.props.history.replace('/lists')
          }
          color="#fff"
          showEdit={stores[cardIndex] === 'Master List'}
          onClickEdit={() => this.setState({ showModal: true, renameList: true })}
          onClickDelete={() => this.setState({ showModal: true, deleteList: true })}
        />
        {isLoading && isEmpty(listsData) ? (
          <PageLoader />
        ) : isEmpty(listsData) ? (
          <div>Empty List</div>
        ) : (
          <React.Fragment>
            <CustomCard
              style={{
                display: shopInStoreMode ? 'none' : 'block'
              }}
              boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
              bgColor="#fff"
              boxRadius="0px"
              padding="10px 11px">
              <CustomSlider itemWidth={148} numberOfItems={get(stores, 'length')} margin="12px 5px">
                {map(stores, (item, idx) => (
                  <React.Fragment>
                    {item === 'Master List' ? (
                      <Card
                        padding="8px"
                        forSlick
                        height="88px"
                        bgColor="#fff"
                        boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                        boxRadius="5px"
                        onClick={() => this.setState({ cardIndex: idx })}
                        activeCard={cardIndex === idx}>
                        <StyledShape
                          className="shape"
                          display="inline-flex"
                          padding="2px 6px"
                          backgroundColor="#fff"
                          boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                          position="absolute"
                          justifyContent="center">
                          <XXMText color="#078489">Master List</XXMText>
                        </StyledShape>
                        <FlexWrapper alignItems="center" justifyContent="center" height="60px">
                          <div style={{ paddingTop: 10 }}>
                            <Icon icon="editList" />
                          </div>
                          <XLMMText color="#124b5f">Edit List</XLMMText>
                        </FlexWrapper>
                      </Card>
                    ) : (
                      <Card
                        key={item}
                        padding="8px"
                        height="auto"
                        forSlick
                        bgColor="#fff"
                        activeCard={cardIndex === idx}
                        onClick={() => this.setState({ cardIndex: idx })}
                        // boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                        boxRadius="5px">
                        {/* <StyledShape
                          display="inline-flex"
                          padding="2px 6px"
                          backgroundColor="#fff"
                          boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                          position="absolute"
                          justifyContent="center">
                          <XLMMText color="#078489">Top Score</XLMMText>
                        </StyledShape> */}
                        {/* <FloatingIcon>
                          <Icon icon="cart" width="24" height="24" />
                        </FloatingIcon> */}
                        <FlexWrapper>
                          <FlexWrapper direction="row" viewMargin="8px 0 16px" alignItems="center">
                            <StyledImage
                              src={get(
                                listsData[item],
                                'grocerInfo.imageUrl',
                                require('../static/images/no-image.png')
                              )}
                              alt={item}
                              height="18px"
                              margin="0 auto 0 0"
                            />
                            <ProgressBar percentage={get(aggregates[item], 'avgGs', 0)} strokeWidth={16} size="28px" />
                          </FlexWrapper>
                        </FlexWrapper>
                        <FlexWrapper direction="row" alignItems="center" justifyContent="space-between">
                          {get(listsData[item], 'grocerInfo.grocerType', '') === 'Online' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 4px 1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              <XXMText color="#00aada">Online</XXMText>
                            </Shape>
                          ) : get(listsData[item], 'grocerInfo.grocerType', '') === 'Insta' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 4px 1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Online'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Online</XXMText>
                              )}
                            </Shape>
                          ) : get(listsData[item], 'grocerInfo.grocerType', '') === 'Mixed' ? (
                            <Shape
                              display="inline-flex"
                              padding="1px 4px 1px 2px"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Online'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Online</XXMText>
                              )}
                            </Shape>
                          ) : (
                            <Shape
                              display="inline-flex"
                              padding="0px 2px 0 0"
                              backgroundColor="#fff"
                              border="1px solid #00aada"
                              margin="0 4px 0 0"
                              borderRadius="18px"
                              justifyContent="center">
                              {get(listsData[item], 'grocerInfo.distance', null) ? (
                                <React.Fragment>
                                  <Icon icon="distance" />
                                  <XXMText color="#00aada">
                                    {`${(get(listsData[item], 'grocerInfo.distance', 0) / 1609.344).toFixed(2)} mi` ||
                                      'Offline'}
                                  </XXMText>
                                </React.Fragment>
                              ) : (
                                <XXMText color="#00aada">Offline</XXMText>
                              )}
                            </Shape>
                          )}
                          <XXXMText fontWeight="bold" color="#124b5f">
                            {`$${
                              get(aggregates[item], 'lowerTotalPrice', 0) === 'na.na'
                                ? '00.00'
                                : get(aggregates[item], 'lowerTotalPrice', 0)
                            }`}
                            {get(aggregates[item], 'asterisk', '0') > 0 ? '*' : ''}
                          </XXXMText>
                        </FlexWrapper>
                      </Card>
                    )}
                  </React.Fragment>
                ))}
              </CustomSlider>
            </CustomCard>
            <PageWrapper viewPadding={shopInStoreMode ? '76px 16px 80px' : '208px 16px 80px'} height="auto">
              <FlexWrap
                justifyContent="space-between"
                height="100%"
                onScroll={this.handleScroll}
                onWheel={this.onScroll}
                style={{ boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)', borderRadius: '6px' }}>
                <ContentWrap>
                  <Card borderRadius="6px" bgColor="#fff" padding={'0'}>
                    <FlexWrapper
                      direction="row"
                      backgroundColor="#f5f5f5"
                      viewPadding="12px 16px"
                      alignItems="center"
                      borderRadius="6px 6px 0 0">
                      <FlexWrapper
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ borderRight: '1px solid #fff' }}>
                        <FlexWrapper width="auto">
                          <XXLText fontWeight="bold">
                            Total: $
                            {get(selectedAggregate, 'lowerTotalPrice', 0) === 'na.na'
                              ? '00.00'
                              : get(selectedAggregate, 'lowerTotalPrice', 0) ===
                                get(selectedAggregate, 'upperTotalPrice', 0)
                              ? get(selectedAggregate, 'lowerTotalPrice', 0)
                              : `${get(selectedAggregate, 'lowerTotalPrice', 0)} -
                                ${get(selectedAggregate, 'upperTotalPrice', 0)}`}
                            {get(selectedAggregate, 'asterisk', '0') > 0 ? '*' : ''}
                          </XXLText>
                          <XXXMText>{get(selectedAggregate, 'totalQty', '')} items</XXXMText>
                        </FlexWrapper>
                        {/* <Shape
                          padding="1px 6px 1px 20px"
                          style={{ position: 'relative' }}
                          backgroundColor="#fff"
                          boxShadow="0 0 2px 0 rgba(0, 0, 0, 0.25)"
                          margin="0 20px 0 0">
                          <div style={{ position: 'absolute', left: '-15px', top: '-4px' }}>
                            <Icon icon="cart" width="32" height="32" />
                          </div>
                          <XMText color="#1a75bb">GSC</XMText>
                          <Arrow
                            rotate="-135"
                            color="#1a75bb"
                            margin="0 0 2px 0"
                            style={{ borderLeft: '1.2px solid #1a75bb', borderBottom: '1.2px solid #1a75bb' }}
                            size="7px"
                          />
                        </Shape> */}
                      </FlexWrapper>
                      <div style={{ height: '43px', width: '1px', background: '#E0E0E0', margin: '0 20px 0 0' }} />
                      <FlexWrapper width="auto">
                        <ProgressBar strokeWidth={16} size="36px" percentage={get(selectedAggregate, 'avgGs', 0)} />
                      </FlexWrapper>
                    </FlexWrapper>
                    <CardWrap>
                      {map(sortedProducts, (item, index) => {
                        if (
                          shopInStoreMode &&
                          item.substitutedProductList &&
                          item.substitutedProductList.length === 0
                        ) {
                          return null
                        }
                        const previousItem = sortedProducts[index - 1]

                        let priceRange = []
                        if (cardIndex === 0) {
                          priceRange = get(item, 'productCost', []).map(p =>
                            p.productPriceSale ? p.productPriceSale : p.productPriceOriginal
                          )
                        } else {
                          if (has(item, 'userSubstituteProduct')) {
                            if (get(item, 'userSubstituteProduct.productCode', '') === 'NONE') {
                              priceRange = item.productPriceSale ? [item.productPriceSale] : [item.productPriceOriginal]
                            } else {
                              priceRange = get(item.userSubstituteProduct, 'productPriceSale', 0)
                                ? [get(item.userSubstituteProduct, 'productPriceSale', 0)]
                                : [get(item.userSubstituteProduct, 'productPriceOriginal', 0)]
                            }
                          } else {
                            priceRange = item.productPriceSale ? [item.productPriceSale] : [item.productPriceOriginal]
                          }
                        }

                        let prodCode,
                          prodImage,
                          prodQty,
                          prodName,
                          prodCat = '',
                          ttlGs = 0,
                          noSubstituteFlag,
                          substituteFillColor = false,
                          radioProductCode: ''
                        if (get(item, 'substitutedProductList', []).length > 0 && !has(item, 'userSubstituteProduct')) {
                          noSubstituteFlag = true
                        }

                        if (has(item, 'userSubstituteProduct')) {
                          prodCode = get(item, 'userSubstituteProduct.productCode', '')
                          prodImage = get(item, 'userSubstituteProduct.productImage', '')
                          prodQty = get(item, 'userSubstituteProduct.productQuantity', '')
                          prodName = get(item, 'userSubstituteProduct.productName', '')
                          prodCat = get(item, 'userSubstituteProduct.productCategory', '')
                          ttlGs = get(item, 'userSubstituteProduct.totalGs', '')
                          substituteFillColor = true
                          radioProductCode = get(item, 'userSubstituteProduct.productCode', '')
                        } else {
                          prodCode = item.productCode
                          prodImage = item.productImage
                          prodQty = item.productQuantity
                          prodName = item.productName
                          prodCat = item.productCategory
                          ttlGs = item.totalGs
                          radioProductCode = item.productCode
                        }

                        if (shopInStoreMode) {
                          return (
                            <React.Fragment>
                              {toUpper(get(previousItem, 'productCategory', '')) !== toUpper(prodCat) && (
                                <Section>
                                  <Tooltip content={toUpper(prodCat)} type="default" />
                                </Section>
                              )}
                              <Card
                                key={prodCode}
                                boxRadius="0 0 5px 5px"
                                // boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                                borderRadius="5px"
                                bgColor={'#fff'}
                                padding={'16px'}
                                filter={substituteFillColor ? 'none' : noSubstituteFlag ? 'none' : 'none'}
                                onClick={() => this.setState({ counterItems: { ...counterItems, counterKey: '' } })}>
                                <OverlayChild
                                  filter={
                                    (item.substitutedProductList && item.substitutedProductList.length === 0) ||
                                    this.state.checkboxes.indexOf(prodCode) > -1
                                      ? 'blur(0px) grayscale(100%) opacity(50%)'
                                      : 'none'
                                  }>
                                  <ListView
                                    component={
                                      <FlexWrapper direction="row" alignItems="center">
                                        <FlexWrapper direction="row" alignItems="center" flexBasis="20%" width="20%">
                                          {shopInStoreMode && (
                                            <Checkbox
                                              circle
                                              checked={this.state.checkboxes.indexOf(prodCode) > -1}
                                              onChange={e => {
                                                this.setState({
                                                  checkboxes: xor(this.state.checkboxes, [prodCode])
                                                })
                                              }}
                                            />
                                          )}
                                          <Circle
                                            size="52px"
                                            minWidth="52px"
                                            boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)"
                                            margin="0 0 0 10px"
                                            onClick={event => {
                                              event.stopPropagation()
                                              this.props.history.push({
                                                pathname: `/products/${prodCode}/green-score`,
                                                state: {
                                                  shopInStoreMode,
                                                  cardIndex,
                                                  scrolledToBottom,
                                                  checkboxes,
                                                  lastPath: get(this.props, 'location.pathname', '')
                                                }
                                              })
                                            }}>
                                            <StyledImage
                                              /* onClick={() =>
                                              this.props.history.push(`/products/${prodCode}/green-score`)
                                            } */
                                              src={prodImage || require('../static/images/no-image.png')}
                                              height="36px"
                                              maxWidth="36px"
                                            />
                                          </Circle>
                                        </FlexWrapper>
                                        <FlexWrapper
                                          flexBasis="70%"
                                          width="70%"
                                          viewPadding="0 0 0 6px"
                                          viewMargin="0 0 0 16px">
                                          {isEmpty(prodQty) ? null : (
                                            <XXXMText>{size(prodQty) < 15 ? toUpper(prodQty) : ''}</XXXMText>
                                          )}
                                          <DefaultText
                                            style={{ height: 48 }}
                                            color="#124b5f"
                                            onClick={event => {
                                              event.stopPropagation()
                                              this.props.history.push({
                                                pathname: `/products/${prodCode}/green-score`,
                                                state: {
                                                  shopInStoreMode,
                                                  cardIndex,
                                                  scrolledToBottom,
                                                  checkboxes,
                                                  lastPath: get(this.props, 'location.pathname', '')
                                                }
                                              })
                                            }}>
                                            {truncate(upperlower(prodName, 'titlecase'), { length: 40 })}
                                          </DefaultText>
                                          <FlexWrapper
                                            direction="row-reverse"
                                            alignItems="center"
                                            justifyContent="flex-end"
                                            width="200px">
                                            <React.Fragment>
                                              <DefaultText color="#078489" padding="0 0 0 10px">
                                                $
                                                {!item.productPriceOriginal
                                                  ? 'na.na'
                                                  : item.productPriceSale || item.productPriceOriginal}
                                              </DefaultText>
                                            </React.Fragment>

                                            <FlexWrapper width="auto">
                                              <CounterFlexWrapper
                                                width="auto"
                                                focused={counterItems.counterKey === prodCode}>
                                                <Counter
                                                  backgroundColor="#fff"
                                                  margin={counterItems.counterKey === prodCode && '0 0 0 -56px'}
                                                  onTouch={event => {
                                                    event.stopPropagation()
                                                    this.setState({
                                                      counterItems: {
                                                        ...this.state.counterItems,
                                                        counterKey: prodCode
                                                      }
                                                    })
                                                  }}
                                                  collapsed={!(counterItems.counterKey === prodCode)}
                                                  value={item.userQuantity}
                                                  onAdd={event => {
                                                    event.stopPropagation()
                                                    this.handleChangeInQuantity(
                                                      stores[cardIndex],
                                                      radioProductCode,
                                                      'add'
                                                    )
                                                  }}
                                                  onSubtract={event => {
                                                    event.stopPropagation()
                                                    this.handleChangeInQuantity(
                                                      stores[cardIndex],
                                                      radioProductCode,
                                                      'subtract'
                                                    )
                                                  }}
                                                />
                                              </CounterFlexWrapper>
                                            </FlexWrapper>
                                          </FlexWrapper>
                                        </FlexWrapper>
                                        <FlexWrapper alignItems="flex-end" flexBasis="10%" width="10%">
                                          <ProgressBar strokeWidth={16} size="36px" percentage={Math.round(ttlGs)} />
                                          {has(item, 'substitutedProductList') &&
                                            (item.substitutedProductList.length === 0 ? (
                                              <Shape
                                                padding="2px"
                                                backgroundColor="#fff"
                                                border="1px solid #208907"
                                                margin="10px 0 0 0"
                                                minWidth="max-content"
                                                justifyContent="center">
                                                <SmallestText color="#208907">No Substitute</SmallestText>
                                              </Shape>
                                            ) : (
                                              <ReplaceFlexWrapper isReplaced={!substituteFillColor}>
                                                <FlexWrapper width="100%" direction="row" justifyContent="flex-end">
                                                  <Shape
                                                    padding="1px 4px"
                                                    backgroundColor={substituteFillColor ? '#208907' : '#fff'}
                                                    border="1px solid #208907"
                                                    margin={'10px 0 0 -26px'}
                                                    justifyContent="center"
                                                    style={{ position: !substituteFillColor && 'relative' }}
                                                    onClick={event => {
                                                      event.stopPropagation()
                                                      this.setState({
                                                        showModal: true,
                                                        replacementList: true,
                                                        originalProduct: item,
                                                        radioButtonProductCode: radioProductCode,
                                                        storeName: get(selectedAggregate, 'store', ''),
                                                        substitutesProducts: [
                                                          ...get(item, 'substitutedProductList', []),
                                                          {
                                                            productCode: 'NONE',
                                                            productName: 'None of the above',
                                                            productImage: require('../static/images/no-image.png'),
                                                            productQuantity: null,
                                                            productCategory: 'NONE',
                                                            totalGs: 0,
                                                            storeName: get(selectedAggregate, 'store', '')
                                                          }
                                                        ]
                                                      })
                                                    }}>
                                                    <Icon
                                                      icon="replacement"
                                                      color={substituteFillColor ? '#fff' : '#208907'}
                                                    />
                                                    <SmallestText color={substituteFillColor ? '#fff' : '#208907'}>
                                                      {substituteFillColor ? 'Replaced' : 'Replace'}
                                                    </SmallestText>
                                                  </Shape>
                                                </FlexWrapper>
                                              </ReplaceFlexWrapper>
                                            ))}
                                        </FlexWrapper>
                                      </FlexWrapper>
                                    }
                                  />
                                </OverlayChild>
                              </Card>
                            </React.Fragment>
                          )
                        } else {
                          return (
                            <React.Fragment>
                              {toUpper(get(previousItem, 'productCategory', '')) !== toUpper(prodCat) && (
                                <Section>
                                  <Tooltip content={toUpper(prodCat)} type="default" />
                                </Section>
                              )}

                              <Card
                                key={prodCode}
                                boxRadius="0 0 5px 5px"
                                // boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                                borderRadius="5px"
                                bgColor={'#fff'}
                                padding={'2.9% 4.5%'}
                                filter={substituteFillColor ? 'none' : noSubstituteFlag ? 'none' : 'none'}
                                onClick={() => this.setState({ counterItems: { ...counterItems, counterKey: '' } })}>
                                <OverlayChild
                                  filter={
                                    item.substitutedProductList && item.substitutedProductList.length === 0
                                      ? 'blur(0px) grayscale(100%) opacity(50%)'
                                      : 'none'
                                  }>
                                  <ListView
                                    component={
                                      <FlexWrapper direction="row" alignItems="center">
                                        <FlexWrapper direction="row" alignItems="center" flexBasis="20%" width="20%">
                                          {shopInStoreMode && (
                                            <Checkbox
                                              circle
                                              onChange={e => {
                                                this.setState({
                                                  checkboxes: xor(this.state.checkboxes, [prodCode])
                                                })
                                              }}
                                            />
                                          )}
                                          <Circle
                                            size="52px"
                                            minWidth="52px"
                                            boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)"
                                            onClick={event => {
                                              event.stopPropagation()
                                              this.props.history.push({
                                                pathname: `/products/${prodCode}/green-score`,
                                                state: {
                                                  shopInStoreMode: shopInStoreMode,
                                                  cardIndex: cardIndex,
                                                  scrolledToBottom: scrolledToBottom,
                                                  lastPath: get(this.props, 'location.pathname', '')
                                                }
                                              })
                                            }}>
                                            <StyledImage
                                              onClick={() =>
                                                this.props.history.push(`/products/${prodCode}/green-score`)
                                              }
                                              src={prodImage || require('../static/images/no-image.png')}
                                              height="36px"
                                              maxWidth="36px"
                                            />
                                          </Circle>
                                        </FlexWrapper>
                                        <FlexWrapper flexBasis="70%" width="70%" viewPadding="0 0 0 0px">
                                          {isEmpty(prodQty) ? null : prodQty.length <= 30 ? (
                                            <XXXMText>{size(prodQty) < 15 ? toUpper(prodQty) : ''}</XXXMText>
                                          ) : null}
                                          <DefaultText
                                            style={{ height: 48 }}
                                            color="#124b5f"
                                            onClick={event => {
                                              event.stopPropagation()
                                              this.props.history.push({
                                                pathname: `/products/${prodCode}/green-score`,
                                                state: {
                                                  shopInStoreMode: shopInStoreMode,
                                                  cardIndex: cardIndex,
                                                  scrolledToBottom: scrolledToBottom,
                                                  lastPath: get(this.props, 'location.pathname', '')
                                                }
                                              })
                                            }}>
                                            {truncate(upperlower(prodName, 'titlecase'), { length: 40 })}
                                          </DefaultText>
                                          <FlexWrapper
                                            direction="row-reverse"
                                            alignItems="center"
                                            justifyContent="flex-end"
                                            width="200px">
                                            <React.Fragment>
                                              <DefaultText color="#078489" padding="0 0 0 10px">
                                                {priceRange[0] === null ? '$na.na' : priceRangeCalculator(priceRange)}
                                              </DefaultText>
                                            </React.Fragment>
                                            <CounterFlexWrapper
                                              focused={counterItems.counterKey === prodCode}
                                              width="auto">
                                              <Counter
                                                backgroundColor="#fff"
                                                margin={counterItems.counterKey === prodCode && '0 0 0 -56px'}
                                                onTouch={event => {
                                                  event.stopPropagation()
                                                  this.setState({
                                                    counterItems: {
                                                      ...this.state.counterItems,
                                                      counterKey: prodCode
                                                    }
                                                  })
                                                }}
                                                collapsed={!(counterItems.counterKey === prodCode)}
                                                value={item.userQuantity}
                                                onAdd={event => {
                                                  event.stopPropagation()
                                                  this.handleChangeInQuantity(
                                                    stores[cardIndex],
                                                    item.productCode,
                                                    'add'
                                                  )
                                                }}
                                                onSubtract={event => {
                                                  event.stopPropagation()
                                                  this.handleChangeInQuantity(
                                                    stores[cardIndex],
                                                    item.productCode,
                                                    'subtract'
                                                  )
                                                }}
                                              />
                                            </CounterFlexWrapper>
                                          </FlexWrapper>
                                        </FlexWrapper>
                                        <FlexWrapper alignItems="flex-end" flexBasis="10%" width="10%">
                                          <ProgressBar strokeWidth={16} size="36px" percentage={Math.round(ttlGs)} />
                                          {has(item, 'substitutedProductList') &&
                                            (item.substitutedProductList.length === 0 ? (
                                              <Shape
                                                padding="2px"
                                                backgroundColor="#fff"
                                                border="1px solid #208907"
                                                margin="10px 0 0 0px"
                                                minWidth="max-content"
                                                justifyContent="center">
                                                <SmallestText color="#208907">No Substitute</SmallestText>
                                              </Shape>
                                            ) : (
                                              <ReplaceFlexWrapper isReplaced={!substituteFillColor}>
                                                <FlexWrapper width="100%" direction="row" justifyContent="flex-end">
                                                  <Shape
                                                    padding="1px 4px"
                                                    backgroundColor={substituteFillColor ? '#208907' : '#fff'}
                                                    border="1px solid #208907"
                                                    margin={'10px 0 0 -26px'}
                                                    minWidth="max-content"
                                                    justifyContent="center"
                                                    style={{ position: !substituteFillColor && 'relative' }}
                                                    onClick={event => {
                                                      event.stopPropagation()
                                                      this.setState({
                                                        showModal: true,
                                                        replacementList: true,
                                                        originalProduct: item,
                                                        radioButtonProductCode: radioProductCode,
                                                        storeName: get(selectedAggregate, 'store', ''),
                                                        substitutesProducts: [
                                                          ...get(item, 'substitutedProductList', []),
                                                          {
                                                            productCode: 'NONE',
                                                            productName: 'None of the above',
                                                            productImage: require('../static/images/no-image.png'),
                                                            productQuantity: null,
                                                            productCategory: 'NONE',
                                                            totalGs: 0,
                                                            storeName: get(selectedAggregate, 'store', '')
                                                          }
                                                        ]
                                                      })
                                                    }}>
                                                    <Icon
                                                      icon="replacement"
                                                      color={substituteFillColor ? '#fff' : '#208907'}
                                                    />
                                                    <SmallestText color={substituteFillColor ? '#fff' : '#208907'}>
                                                      {substituteFillColor ? 'Replaced' : 'Replace'}
                                                    </SmallestText>
                                                  </Shape>
                                                </FlexWrapper>
                                              </ReplaceFlexWrapper>
                                            ))}
                                        </FlexWrapper>
                                      </FlexWrapper>
                                    }
                                  />
                                </OverlayChild>
                              </Card>
                            </React.Fragment>
                          )
                        }
                      })}
                    </CardWrap>
                  </Card>
                </ContentWrap>
              </FlexWrap>
              <CustomFlex direction="row" viewPadding="16px" justifyContent="center">
                <FlexWrapper width="auto" direction="row" alignItems="center">
                  {shopInStoreMode ? (
                    <Button
                      label="SCAN RECEIPT"
                      className="scan-receipt"
                      margin="16px 0 0 0"
                      scanNow
                      onClick={() => this.props.history.push('/scan-receipt')}
                    />
                  ) : get(selectedStore, 'grocerInfo.storeName', '') === 'Master List' ? (
                    <Button
                      label="ADD PRODUCTS TO LIST"
                      social
                      icon="products"
                      color="#078489"
                      iconHeight="18"
                      iconWidth="20"
                      margin="16px 0 0 0"
                      orderNow
                      changeColor={'#078489'}
                      onClick={() => this.props.history.push('/products')}
                    />
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Insta' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ warningModal: true })}
                        label="ORDER ON"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={require('../static/images/instacart.png')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Mixed' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ comingSoonModel: true })}
                        namespace="Order On"
                        label="ORDER ON"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Offline' ? (
                    <React.Fragment>
                      <Button
                        label="SHOP IN STORE"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        onClick={() => this.setState({ shopInStoreMode: true, checkboxes: [] })}
                      />
                      <Button
                        onClick={() => this.setState({ comingSoonModel: true })}
                        label="ORDER ON"
                        namespace="Order On"
                        margin="16px 0 0 0"
                        orderNow
                        changeColor={'#078489'}
                        image={
                          <StyledImage
                            maxWidth="70px"
                            src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                            alt={stores[cardIndex]}
                            margin="0"
                            height="26px"
                          />
                        }
                      />
                    </React.Fragment>
                  ) : get(selectedStore, 'grocerInfo.grocerType', '') === 'Online' ? (
                    <Button
                      onClick={() => this.setState({ comingSoonModel: true })}
                      label="ORDER ON"
                      namespace="Order On"
                      margin="16px 0 0 0"
                      orderNow
                      changeColor={'#078489'}
                      image={
                        <StyledImage
                          maxWidth="70px"
                          src={get(selectedStore, 'grocerInfo.imageUrl', '')}
                          alt={stores[cardIndex]}
                          margin="0"
                          height="26px"
                        />
                      }
                    />
                  ) : null}
                </FlexWrapper>
              </CustomFlex>
            </PageWrapper>

            <Modal
              title={
                renameList ? 'Edit List Name' : deleteList ? 'Delete List' : replacementList ? 'Choose Replacement' : ''
              }
              show={showModal}
              hide={!showModal}
              viewPadding={replacementList && '0px'}
              maxHeight={replacementList && '540px'}
              zIndexOverlay={99999999}
              zIndex={999999}
              onClose={() => this.setState({ showModal: false, renameList: false, deleteList: false })}>
              <FlexWrapper alignItems="center">
                {deleteList ? (
                  <React.Fragment>
                    <XLMText>Are you sure want to delete this list?</XLMText>
                    <Button
                      onClick={async () => {
                        await axios.delete(`${API_URL}/ShoppingLists/${listDetails.id}`)
                        window.location.href = '/lists'
                      }}
                      size="small"
                      label="Delete"
                      namespace="Delete List"
                      volume="filled"
                      margin="48px 0 0 0"
                      type="submit"
                    />
                  </React.Fragment>
                ) : renameList ? (
                  <React.Fragment>
                    <Formik
                      enableReinitialize
                      initialValues={{ title: listDetails.name }}
                      validate={addList}
                      validateOnChange
                      onSubmit={async val => {
                        try {
                          const { data } = await axios.patch(`${API_URL}/ShoppingLists/${listDetails.id}`, {
                            name: val.title
                          })
                          this.fetchListDetails()
                          this.setState({ showModal: false, deleteList: false })
                          // await this.setState({ listExist: true, showModal: true })
                          console.log('DATA LIST', data)
                        } catch (error) {
                          console.error('ERROR', error)
                        }
                      }}
                      render={formikBag => (
                        <FormikForm>
                          <Field
                            name="title"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                width="auto"
                                type="text"
                                label="Name"
                                error={formikBag.errors.title}
                              />
                            )}
                          />
                          <FlexWrapper alignItems="center">
                            <Button
                              size="small"
                              label="Update"
                              volume="filled"
                              namespace="Rename List"
                              margin="14px 0 0 0"
                              type="submit"
                            />
                          </FlexWrapper>
                        </FormikForm>
                      )}
                    />
                  </React.Fragment>
                ) : replacementList ? (
                  <React.Fragment>
                    <Card
                      boxRadius="0"
                      boxShadow="none"
                      bgColor={'#f5f5f5'}
                      padding={'2.9% 4.5%'}
                      onClick={event => {
                        event.stopPropagation()
                        this.props.history.push({
                          pathname: `/products/${this.state.originalProduct.productCode}/green-score`,
                          state: {
                            lastPath: get(this.props, 'location.pathname', ''),
                            cardIndex: cardIndex,
                            showModal: this.state.showModal,
                            storeName: this.state.storeName,
                            replacementList: this.state.replacementList,
                            originalProduct: this.state.originalProduct,
                            radioButtonProductCode: this.state.radioButtonProductCode,
                            substitutesProducts: this.state.substitutesProducts
                          }
                        })
                      }}>
                      <ListView
                        component={
                          <FlexWrapper direction="row" alignItems="center">
                            <FlexWrapper direction="row" alignItems="center" flexBasis="20%" width="20%">
                              <Circle size="52px" minWidth="52px" boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)">
                                <StyledImage
                                  onClick={() =>
                                    this.props.history.push({
                                      pathname: `/products/${this.state.originalProduct.productCode}/green-score`,
                                      state: {
                                        lastPath: get(this.props, 'location.pathname', ''),
                                        cardIndex: cardIndex,
                                        showModal: this.state.showModal,
                                        storeName: this.state.storeName,
                                        replacementList: this.state.replacementList,
                                        originalProduct: this.state.originalProduct,
                                        radioButtonProductCode: this.state.radioButtonProductCode,
                                        substitutesProducts: this.state.substitutesProducts
                                      }
                                    })
                                  }
                                  src={get(
                                    this.state.originalProduct,
                                    'productImage',
                                    require('../static/images/no-image.png')
                                  )}
                                  height="36px"
                                  maxWidth="36px"
                                />
                              </Circle>
                            </FlexWrapper>
                            <FlexWrapper
                              flexBasis="70%"
                              width="70%"
                              onClick={() =>
                                this.props.history.push({
                                  pathname: `/products/${this.state.originalProduct.productCode}/green-score`,
                                  state: {
                                    lastPath: get(this.props, 'location.pathname', ''),
                                    cardIndex: cardIndex,
                                    showModal: this.state.showModal,
                                    storeName: this.state.storeName,
                                    replacementList: this.state.replacementList,
                                    originalProduct: this.state.originalProduct,
                                    radioButtonProductCode: this.state.radioButtonProductCode,
                                    substitutesProducts: this.state.substitutesProducts
                                  }
                                })
                              }>
                              {isEmpty(this.state.originalProduct.productQuantity) ? null : this.state.originalProduct
                                  .productQuantity.length <= 30 ? (
                                <XXXMText>
                                  {size(get(this.state.originalProduct, 'productCost[0].productQuantity', '')) < 15
                                    ? toUpper(this.state.originalProduct.productQuantity)
                                    : ''}
                                </XXXMText>
                              ) : null}
                              <DefaultText color="#124b5f">
                                {truncate(upperlower(this.state.originalProduct.productName, 'titlecase'), {
                                  length: 24
                                })}
                              </DefaultText>
                              <FlexWrapper
                                direction="row-reverse"
                                alignItems="center"
                                justifyContent="flex-end"
                                width="200px">
                                <React.Fragment>
                                  <XMText color="#078489">
                                    $
                                    {!this.state.originalProduct.productPriceOriginal
                                      ? 'na.na'
                                      : this.state.originalProduct.productPriceSale ||
                                        this.state.originalProduct.productPriceOriginal}
                                  </XMText>
                                </React.Fragment>
                              </FlexWrapper>
                            </FlexWrapper>
                            <FlexWrapper alignItems="flex-end" flexBasis="10%" width="10%">
                              <ProgressBar
                                strokeWidth={16}
                                size="36px"
                                percentage={Math.round(this.state.originalProduct.totalGs)}
                              />
                            </FlexWrapper>
                          </FlexWrapper>
                        }
                      />
                    </Card>
                    {uniqBy(this.state.substitutesProducts, 'productCode')
                      .slice(0, 10)
                      .map((item, idx) => {
                        const previousIte = this.state.substitutesProducts[idx - 1]
                        return (
                          <React.Fragment>
                            {toUpper(get(previousIte, 'productCategory', '')) !== toUpper(item.productCategory) && (
                              <Section>
                                <Tooltip content={toUpper(item.productCategory)} type="default" />
                              </Section>
                            )}
                            <Card
                              boxRadius="0"
                              boxShadow="none"
                              bgColor={'#fff'}
                              padding={'2.9% 4.5%'}
                              onClick={event => {
                                event.stopPropagation()
                              }}>
                              <ListView
                                component={
                                  <FlexWrapper direction="row" alignItems="center">
                                    <FlexWrapper direction="row" alignItems="center" flexBasis="20%" width="20%">
                                      <Radio
                                        name={item.productCode}
                                        value={item.productCode}
                                        checked={this.state.radioButtonProductCode === item.productCode}
                                        onChange={obj =>
                                          this.setState({ radioButtonProductCode: obj, storeName: item.storeName })
                                        }
                                      />
                                      <Circle size="52px" minWidth="52px" boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.19)">
                                        <StyledImage
                                          onClick={() =>
                                            item.productCode === 'NONE'
                                              ? ''
                                              : this.props.history.push({
                                                  pathname: `/products/${item.productCode}/green-score`,
                                                  state: {
                                                    lastPath: get(this.props, 'location.pathname', ''),
                                                    cardIndex: cardIndex,
                                                    showModal: this.state.showModal,
                                                    storeName: this.state.storeName,
                                                    replacementList: this.state.replacementList,
                                                    originalProduct: this.state.originalProduct,
                                                    radioButtonProductCode: this.state.radioButtonProductCode,
                                                    substitutesProducts: this.state.substitutesProducts
                                                  }
                                                })
                                          }
                                          src={get(item, 'productImage', require('../static/images/no-image.png'))}
                                          height="36px"
                                          maxWidth="36px"
                                        />
                                      </Circle>
                                    </FlexWrapper>
                                    <FlexWrapper
                                      flexBasis="70%"
                                      width="70%"
                                      viewPadding="0 0 0 6px"
                                      viewMargin="0 0 0 16px"
                                      onClick={() =>
                                        item.productCode === 'NONE'
                                          ? ''
                                          : this.props.history.push({
                                              pathname: `/products/${item.productCode}/green-score`,
                                              state: {
                                                lastPath: get(this.props, 'location.pathname', ''),
                                                cardIndex: cardIndex,
                                                showModal: this.state.showModal,
                                                storeName: this.state.storeName,
                                                replacementList: this.state.replacementList,
                                                originalProduct: this.state.originalProduct,
                                                radioButtonProductCode: this.state.radioButtonProductCode,
                                                substitutesProducts: this.state.substitutesProducts
                                              }
                                            })
                                      }>
                                      {isEmpty(item.productQuantity) ? null : item.productQuantity.length <= 30 ? (
                                        <XXXMText>
                                          {size(get(item, 'productCost[0].productQuantity', '')) < 15
                                            ? toUpper(item.productQuantity)
                                            : ''}
                                        </XXXMText>
                                      ) : null}
                                      <DefaultText color="#124b5f">
                                        {truncate(upperlower(item.productName, 'titlecase'), { length: 40 })}
                                      </DefaultText>
                                      <FlexWrapper
                                        direction="row-reverse"
                                        alignItems="center"
                                        justifyContent="flex-end"
                                        width="200px">
                                        {item.productCode !== 'NONE' && (
                                          <React.Fragment>
                                            <XMText color="#078489">
                                              $
                                              {!item.productPriceOriginal
                                                ? 'na.na'
                                                : item.productPriceSale || item.productPriceOriginal}
                                            </XMText>
                                          </React.Fragment>
                                        )}
                                      </FlexWrapper>
                                    </FlexWrapper>
                                    <FlexWrapper alignItems="flex-end" flexBasis="10%" width="10%">
                                      <ProgressBar strokeWidth={16} size="36px" percentage={Math.round(item.totalGs)} />
                                    </FlexWrapper>
                                  </FlexWrapper>
                                }
                              />
                            </Card>
                          </React.Fragment>
                        )
                      })}
                    <Button
                      size="small"
                      label="Confirm"
                      namespace="Add Item List"
                      volume="filled"
                      margin="20px 0 0 0"
                      disabled={
                        indexOf(
                          uniqBy(this.state.substitutesProducts, 'productCode').map(item => item.productCode),
                          this.state.radioButtonProductCode
                        ) === -1
                          ? true
                          : false
                      }
                      // isLoading={isLoading}
                      onClick={() => this.updateReplacement()}
                    />
                  </React.Fragment>
                ) : null}
              </FlexWrapper>
            </Modal>
            <Modal
              show={comingSoonModel}
              hide={!comingSoonModel}
              onClose={() => this.setState({ comingSoonModel: false })}>
              <FlexWrapper alignItems="center">
                <XCMText>Coming Soon!</XCMText>
              </FlexWrapper>
            </Modal>
            <Modal
              title="Attention"
              show={warningModal}
              hide={!warningModal}
              // list={openList || listExist}
              onClose={() => {
                this.setState({ warningModal: false })
                this.createInstaUrl()
              }}>
              <FlexWrapper alignItems="center">
                <XXLText>
                  Instacart may select the wrong grocer for you! You may have to select the grocer you want before you
                  "Continue to recipe".
                </XXLText>
                <br />
                <Button
                  label="Continue"
                  margin="0 10px"
                  size="small"
                  onClick={() => {
                    this.setState({ warningModal: false })
                    this.createInstaUrl()
                  }}
                />
              </FlexWrapper>
            </Modal>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false
  }
})(SingleList)



// WEBPACK FOOTER //
// ./src/pages/SingleList.js